import React from 'react'
import { Icon } from '../Icon'

interface UIFieldErrorProps {
  errorMessage?: string
  className?: string
}

const UIFieldError: React.FC<UIFieldErrorProps> = ({
  errorMessage,
  className,
}) => {
  return (
    <div
      className={`w-fit px-3 py-2 rounded-[12px] flex items-center gap-2 bg-palePink ${className}`}
    >
      <Icon
        name={'IconAlertTriangle'}
        width={16}
        height={16}
        strokeWidth={1}
        stroke={'#FF6666'}
      />
      <p className="font-semibold text-sm text-left text-text2">
        {errorMessage}
      </p>
    </div>
  )
}

export default UIFieldError
